<template>
  <div id="app" style="overflow: hidden;">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener('hashchange', () => {
      let currentPath = window.location.hash.slice(1)
      if (this.$route.path !== currentPath) {
        this.$router.push(currentPath)
      }
    }, false)
    // APP.vue
// // 禁止缩放
    // document.addEventListener("touchmove",function(e){e.preventDefault()});

window.onload = function() {
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    });
  }
// let self = this;
//     document.addEventListener('touchstart', (e) => {
//       self.moveY = e.targetTouches[0].pageY;
//     })
//     document.addEventListener('touchmove', (e) => {
//       e.preventDefault();
//       let moveWidth = self.moveY - e.targetTouches[0].pageY;
//       if (moveWidth !== 0) {
//         document.body.scrollTop += moveWidth;
//       }
//     })

// };
}
}
</script>

<style>

html,body {
    /* touch-action: pan-y; */
    /* touch-action: pan-x; */
}
 
</style>
